import { useTranslation } from "react-i18next";import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "@/shared/utils";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef(({ className, sideOffset = 4, ...props }, ref) =>
<TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      "z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-tooltip-content-transform-origin]",
      className
    )}
    {...props} />
  </TooltipPrimitive.Portal>
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;


const InfoTooltip = ({ content }) =>
<TooltipProvider>
    <Tooltip>
      <TooltipTrigger>
        <span className="text-muted-foreground hover:text-foreground cursor-help">ⓘ</span>
      </TooltipTrigger>
      <TooltipContent>
        <p>{content}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>;


const TermTooltip = ({ term, definition }) =>
<TooltipProvider>
    <Tooltip>
      <TooltipTrigger>
        <span className="underline decoration-dotted cursor-help">{term}</span>
      </TooltipTrigger>
      <TooltipContent>
        <p>{definition}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>;


export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider, InfoTooltip, TermTooltip };